import React from "react";
import { Bar, Chart, Doughnut, Line } from "react-chartjs-2";

import NoDataFoundIcon from "../../../components/Common/SvgIcons/ReportIcons/NoDataFoundIcon";
import classes from "./ReportGraph.module.scss";
// Chart.register(ChartDataLabels);

const ReportGraph = ({
  graphData,
  totalPercentage,
  heading = "",
  type,
  cutout = "40",
  yAxesText,
  xAxesText,
  isLegend = false,
  aspectRatio = "2",
}) => {
  var doughnutoptions = {
    plugins: {
      legend: {
        display: false,
        position: "right",
        borderWidth: 2,
      },
    },

    cutout: cutout + "%",
    aspectRatio: aspectRatio,
  };
  // console.log(totalPercentage)
  const verticalBarOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: isLegend,
        position: "bottom",
      },

      datalabels: {
        anchor: "end",
        align: "top",
        formatter: Math.round,
        font: {
          size: 20,
        },
      },
    },
    scales: {
      // y: {
      //   beginAtZero: true,
      //   max: 100,
      // },
      yAxes: {
        title: {
          display: true,
          text: yAxesText,
          font: {
            size: 10,
          },
        },
        ticks: {
          precision: 0,
        },
      },
      xAxes: {
        title: {
          display: true,
          text: xAxesText,
          font: {
            size: 10,
          },
        },
      },
    },
  };

  const lineOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
        position: "top",
      },
      title: {
        display: false,
        text: "Chart.js Line Chart",
      },
    },
    scales: {
      yAxes: {
        title: {
          display: true,
          text: yAxesText,
          font: {
            size: 10,
          },
        },
        ticks: {
          precision: 0,
        },
      },
      xAxes: {
        title: {
          display: true,
          text: xAxesText,
          font: {
            size: 10,
          },
        },
      },
    },
  };

  const horizontalBarOptions = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: isLegend,
        position: "bottom",
      },
    },
    scales: {
      yAxes: {
        title: {
          display: true,
          text: yAxesText,
          font: {
            size: 10,
          },
        },
        // ticks: {
        //   precision: 0,
        // },
        ticks: {
          autoSkip: false,
          callback: function (value) {
            const label = this.getLabelForValue(value);
            return label.length > 40 ? label.substr(0, 40) + "..." : label;
          },
        },
      },
      xAxes: {
        title: {
          display: false,
          text: xAxesText,
          font: {
            size: 10,
          },
        },
        ticks: {
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
        },
      },
    },
    // plugins: {
    //   tooltip: {
    //     callbacks: {
    //       label: function (tooltipItem) {
    //         const label = tooltipItem.label;
    //         return label.length > 40 ? label : label;
    //       },
    //       title: function (tooltipItems) {
    //         return tooltipItems[0].label;
    //       },
    //     },
    //   },
    //   customHover: {
    //     id: 'customHover',
    //     afterEvent: function(chart, event) {
    //       const { ctx, scales: { y } } = chart;
    //       const { offsetX, offsetY } = event.event;
    //       const yValue = y.getValueForPixel(offsetY);
    //       const label = chart.data.labels[yValue];
    //       if (label) {
    //         ctx.save();
    //         ctx.font = 'bold 12px Arial';
    //         ctx.fillStyle = 'black';
    //         ctx.fillText(label, offsetX, offsetY);
    //         ctx.restore();
    //       }
    //     },
    //   },
    // },
    // hover: {
    //   mode: "nearest",
    //   intersect: true,
    // },
    // plugins: {
    //   tooltip: {
    //     callbacks: {
    //       label: function (tooltipItem) {
    //         return tooltipItem.label;
    //       },
    //     },
    //   },
    // },
  };

  const groupedBarOptions = {
    indexAxis: "x",
    plugins: {
      legend: {
        display: isLegend,
        position: "bottom",
      },
      datalabels: {
        anchor: "end",
        align: "top",
        formatter: Math.round,
        font: {
          weight: "bold",
          size: 16,
        },
      },
    },

    scales: {
      yAxes: {
        barPercentage: 0.9,
        categoryPercentage: 1,
        title: {
          display: true,
          text: yAxesText,
          font: {
            size: 10,
          },
        },
        ticks: {
          precision: 0,
        },
      },
      xAxes: {
        title: {
          display: true,
          text: xAxesText,
          font: {
            size: 10,
          },
        },
      },
    },
  };

  const stackedBarOptions = {
    indexAxis: "x",
    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
    },
    scales: {
      yAxes: {
        barThickness: 6,
        stacked: true,
        title: {
          display: true,
          text: yAxesText,
          font: {
            size: 10,
          },
        },
        ticks: {
          precision: 0,
        },
      },
      xAxes: {
        barThickness: 6,
        stacked: true,
        title: {
          display: true,
          text: xAxesText,
          font: {
            size: 10,
          },
        },
      },
    },
  };

  return (
    <div>
      <div className={classes.chartHeading}>{heading}</div>
      {type === "doughnut" ? (
        <div className={classes.reportLegends}>
          <div className={classes.reportLegends_innerDiv}>
            {totalPercentage !== 0 && (
              <Doughnut data={graphData} options={doughnutoptions} />
            )}
            {graphData?.datasets?.map((e, i) =>
              e.backgroundColor?.map((backClr, i) => {
                return (
                  <>
                    <span
                      style={{
                        display: "inline-block",
                        width: 16 + "px",
                        height: 15 + "px",
                        marginRight: 10 + "px",
                        backgroundColor: backClr,
                      }}
                    ></span>
                    <span style={{ fontSize: 14 + "px", color: "#404040" }}>
                      {graphData?.labels[i]}
                    </span>{" "}
                    <span style={{ fontSize: 14 + "px", color: "#404040" }}>
                      {graphData?.datasets[0]?.data[i]}%
                    </span>
                    <br></br>
                  </>
                );
              })
            )}
          </div>
        </div>
      ) : type === "verticalBar" ? (
        <div className={classes.graphMain}>
          <Bar data={graphData} options={verticalBarOptions} />
        </div>
      ) : type === "horizontalBar" ? (
        <div className={classes.graphMain}>
          <Bar data={graphData} options={horizontalBarOptions} />
        </div>
      ) : type === "lineGraph" ? (
        <div className={classes.graphMain} style={{ marginTop: 90 + "px" }}>
          <Line data={graphData} options={lineOptions} />
        </div>
      ) : type === "stackedBar" ? (
        <Bar data={graphData} options={stackedBarOptions} />
      ) : type === "groupedBar" ? (
        <Bar data={graphData} options={groupedBarOptions} />
      ) : (
        <></>
      )}
    </div>
  );
};

export default ReportGraph;
